import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { IoMenu } from "react-icons/io5";
import { RxCross2 } from "react-icons/rx";
import { useMyContext } from "../store/ContextApi";
import { AiOutlineHome, AiOutlineClockCircle, AiOutlineHistory } from "react-icons/ai";
import { BsPersonWorkspace } from "react-icons/bs";
import { FiLogIn, FiLogOut } from "react-icons/fi";
import ThemeSelector from "./ThemeSelector";

const Navbar = () => {
  const [headerToggle, setHeaderToggle] = useState(false);
  const pathName = useLocation().pathname;
  const navigate = useNavigate();
  const { token, logout } = useMyContext();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const isActive = (path) => {
    if (path === "/timesheetsthismonth") {
      return pathName === path || pathName.startsWith("/timesheets/");
    }
    return pathName === path;
  };

  const navLinks = [
    { path: "/", icon: <AiOutlineHome className="text-lg" />, text: "Home" },
    { requiresAuth: true, path: "/timesheetsthismonth", icon: <AiOutlineClockCircle className="text-lg" />, text: "Timesheet" },
    { requiresAuth: true, path: "/timesheets/past", icon: <AiOutlineHistory className="text-lg" />, text: "Past Timesheets" },
    { path: "/projects", icon: <BsPersonWorkspace className="text-lg" />, text: "Projects" },
  ];

  const linkClass = (path) =>
    `flex items-center gap-2 rounded-lg px-3 py-2 text-sm font-medium transition-colors ${
      isActive(path)
        ? "nav-link-active"
        : "text-theme-muted hover:bg-theme-nav-hover hover:text-theme-text"
    }`;

  return (
      <header className="sticky top-0 z-50 border-b border-theme-nav-border bg-theme-nav backdrop-blur-md">
        <nav className="mx-auto flex h-16 max-w-6xl items-center justify-between gap-3 px-4 sm:px-6 lg:px-8">
          <Link to="/" className="flex shrink-0 items-center gap-2.5">
            <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-brand-600 text-white shadow-sm">
              <AiOutlineClockCircle className="text-lg" />
            </div>
            <span className="text-base font-bold tracking-tight text-theme-text">Time Tracker</span>
          </Link>

          <div className="hidden items-center gap-2 lg:flex">
            <ThemeSelector compact />
          </div>

          <ul className={`lg:static absolute left-0 top-16 w-full lg:w-fit lg:px-0 px-4 lg:bg-transparent bg-theme-nav backdrop-blur-md z-50 ${
              headerToggle
                  ? "py-3 shadow-lg lg:shadow-none border-b border-theme-border lg:border-0"
                  : "h-0 overflow-hidden"
          } lg:h-auto transition-all duration-200 flex lg:flex-row flex-col lg:items-center lg:gap-1 gap-1`}
          >
            {navLinks
                .filter(link => !link.requiresAuth || token)
                .map((link) => (
                <li key={link.path}>
                  <Link
                      to={link.path}
                      className={linkClass(link.path)}
                      onClick={() => setHeaderToggle(false)}
                  >
                    {link.icon}
                    <span>{link.text}</span>
                  </Link>
                </li>
            ))}
            {!token && (
                <li>
                  <Link
                      to="/login"
                      className={linkClass('/login')}
                      onClick={() => setHeaderToggle(false)}
                  >
                    <FiLogIn className="text-lg" />
                    <span>Login</span>
                  </Link>
                </li>
            )}
            {token && (
                <li className="lg:ml-2 lg:border-l lg:border-theme-border lg:pl-2">
                  <button
                      onClick={handleLogout}
                      className="flex w-full items-center gap-2 rounded-lg px-3 py-2 text-sm font-medium text-rose-500 transition-colors hover:bg-rose-500/10"
                  >
                    <FiLogOut className="text-lg" />
                    <span>Logout</span>
                  </button>
                </li>
            )}
            <li className="pt-2 lg:hidden">
              <ThemeSelector compact />
            </li>
          </ul>

          <button
              className="lg:hidden rounded-lg p-2 text-theme-muted hover:bg-theme-nav-hover"
              onClick={() => setHeaderToggle(!headerToggle)}
              aria-label="Toggle menu"
          >
            {headerToggle ? <RxCross2 className="text-xl" /> : <IoMenu className="text-xl" />}
          </button>
        </nav>
      </header>
  );
};

export default Navbar;
